<script setup lang="ts">
defineProps<{ size: number }>();
</script>

<template>
  <svg :width="size" :height="size" viewBox="0 0 16 16" fill="currentColor">
    <path d="M4 6.3l7.5-3.3v10L4 9.7z"/>
    <rect x="1.6" y="5.9" width="2.6" height="4.2" rx="1.1"/>
    <rect x="6.4" y="9.6" width="2" height="4.4" rx="1"/>
  </svg>
</template>
